import React, { useEffect, useRef, useState } from "react";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { useSelector } from "react-redux";
import bgGrad from "../../assets/img/bgGrad.png";
import ApplicationCategoryTab from "../../pages/applicationCategoryTab";
import AssignedApplication from "../Application/Assigned";
import SearchbarMobile from "../ForMobile/SearchbarMobile";
import { Tab, Nav } from "react-bootstrap";
import { AppTrainingIcon, BottomActiveBar } from "../../Icons";
import SearchFullScreen from "../ForMobile/SearchFullScreen";
import ScrollFixedSearch from "../ForMobile/ScrollFixedSearch";

const { SearchBar, SimTabs } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const Home = ({ isMobileView }) => {
  const { searchValue } = useSelector((state) => state.searchSlice);
  const myApplications = useUnoSelector((state) => state.application);
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const applicationData = useSelector((state) => state.applicationSlice);
  const [search, setSearch] = useState("");
  const [searchMode, setSearchMode] = useState(false);
  const [accessAllTabs, setAccessAllTabs] = useState([]);
  const [activeTab, setActiveTab] = useState("accessed");
  const [applicationTypeTab, setApplicationTypeTab] = useState([]);

  const handleClick = (key) => {
    setActiveTab(key);
  };

  const mobSearchRef = useRef(null);
  ScrollFixedSearch(mobSearchRef, "applicationheader");

  useEffect(() => {
    setSearch(searchValue);
  }, [searchValue]);

  useEffect(() => {
    const accessedTab = [
      {
        navItem: { title: "Accessed" },
        content: {
          component: () => (
            <>
              <div className="list-parent taglinebottom">
                <AssignedApplication search={search} />
                {/* <div className="tagLine">
                  <h1>
                    <span>Mastering Skills,</span> <span>Empowering Futures.</span>
                  </h1>
                  <p>Made in India ❤️ from Simulanis Solution</p>
                </div> */}
              </div>
            </>
          ),
        },
        key: "accessed",
      },
    ];

    setAccessAllTabs(accessedTab);
  }, [applicationData, search]);

  useEffect(() => {
    if (applicationData?.applicationsCategory) {
      let list = applicationData?.applicationsCategory.tags;
      let appAllowedTabs = (configData.config.appPermission || []).map((name) => name.toLowerCase());
      let allowedTabs = list?.filter((item) => appAllowedTabs?.includes(item.name.toLowerCase()));

      const newTabData = allowedTabs?.map((item) => {
        return {
          navItem: { title: item.name },
          key: `tab${item.id}`,
          content: {
            component: () => (
              <>
                <ApplicationCategoryTab
                  categoryId={item.id}
                  UNO_URL={configData.config.UNO_URL}
                  token={userData.token}
                  search={search}
                  assignedApp={myApplications.apps || []}
                />
              </>
            ),
          },
        };
      });

      setApplicationTypeTab(newTabData || []);
    }
  }, [applicationData, search, configData, myApplications]);

  let allApplicationsWithTabs = [...accessAllTabs, ...applicationTypeTab];

  return (
    <div className="home">
      {!isMobileView ? (
        <>
          <div className="page-title mb-0">
            <h6> Applications </h6>
            <div className="search-parent">
              <SearchBar placeholder="Search Application" value={search} onChange={(e) => setSearch(e.target.value)} />
            </div>
          </div>
          <div className="for-tabs pt-3">
            <SimTabs
              data={allApplicationsWithTabs}
              setActiveTab={(e) => setActiveTab(e)}
              defaultActiveKey={activeTab}
              nav_wrapper_class="with-search"
            ></SimTabs>
          </div>
        </>
      ) : (
        <>
          <Tab.Container activeKey={activeTab} onSelect={handleClick}>
            <div className="for-tabs mobile">
              <div className="mobileHead">
                {/* <img src={bgGrad} alt="bg" className="bgGrad" referrerPolicy="no-referrer" /> */}
                <div className="inpInfo">
                  {/* <p>Simulanis Uno</p> */}
                  <h6>Hi {userData?.user?.name}</h6>
                </div>
                <div ref={mobSearchRef}>
                  <div className="page-title mob">
                    <div className="mobSearchParent">
                      <SearchbarMobile showFilterBtn={false} searchAnimated={false} searchMode={searchMode} />
                    </div>
                  </div>
                  <div className="tabsMobile">
                    <Nav variant="pills" className="tabfull">
                      {allApplicationsWithTabs?.map((item) => (
                        <Nav.Item key={item?.key}>
                          <Nav.Link eventKey={item?.key}>
                            {/* <span className="tabIcon">
                            <AppTrainingIcon />
                          </span> */}
                            <span className="tabText">{item?.navItem.title}</span>
                            <span className="activeIndicator">
                              <BottomActiveBar />
                            </span>
                          </Nav.Link>
                        </Nav.Item>
                      ))}
                    </Nav>
                  </div>
                </div>
              </div>
              <div>
                <Tab.Content>
                  {allApplicationsWithTabs?.map((item) => (
                    <Tab.Pane eventKey={item?.key} key={item?.key}>
                      {item?.content?.component()}
                    </Tab.Pane>
                  ))}
                </Tab.Content>
              </div>
            </div>
          </Tab.Container>
        </>
      )}
    </div>
  );
};

export default Home;
